import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import { typeViewBy } from '../../constant'
import classes from '../../index.module.scss'
import { EachYear } from './EachYear'
import Table from './Table'
import { Trend } from './Trend'
import { selectLoading } from './store/slice'

const EarningBreakdown = ({ viewBy, id }) => {
  const loading = useSelector(selectLoading)

  return (
    <Element
      className={`h100 ${classes.containerPanel}`}
      style={{ color: '#3A414B' }}
    >
      {loading ? (
        <Loading />
      ) : viewBy === typeViewBy.TREND ? (
        <Trend id={id} />
      ) : viewBy === typeViewBy.EACH_YEAR ? (
        <EachYear id={id} />
      ) : (
        <Table id={id} />
      )}
    </Element>
  )
}

export default EarningBreakdown
